import dayjs from 'dayjs';

import { LATEST_TOKEN_VALID_DATE } from './accountsJwtService.constants';

class JwtManager {
  #tokenBackend;
  #storageKey;

  constructor(tokenBackend) {
    this.#tokenBackend = tokenBackend;
    this.#storageKey = 'lsAccountsJwtToken';
  }

  #getTokensData = () => {
    return this.#tokenBackend.getParsedItem(this.#storageKey);
  };

  setToken = tokenData => {
    if (tokenData) {
      return this.#tokenBackend.setItem(this.#storageKey, tokenData, true);
    }

    return this.#tokenBackend.removeItem(this.#storageKey);
  };

  getAccessToken = () => {
    const tokenData = this.#getTokensData();

    return tokenData?.accessValue;
  };

  getAccessTokenValue = () => {
    const tokenData = this.#getTokensData();

    return tokenData?.accessValue?.value;
  };

  getRefreshToken = () => {
    const tokenData = this.#getTokensData();

    return tokenData?.refreshValue;
  };

  getRefreshTokenValue = () => {
    const tokenData = this.#getTokensData();

    return tokenData?.refreshValue?.value;
  };

  getIsTokenValid = token => {
    return !!token && !this.getIsTokenExpired(token);
  };

  getIsTokenExpired = token => {
    const latestTokenValidDate = dayjs().add(LATEST_TOKEN_VALID_DATE, 'seconds');

    return dayjs(token.expirationDate).isBefore(latestTokenValidDate);
  };
}

export default JwtManager;
